if(!customElements.get("custom-product-variants")) {
  customElements.define("custom-product-variants", 
    class CustomProductVariants extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        console.log('haloo')
        this.form = this.querySelector("form");
        this.submitButton = this.querySelector("#submitButton");
        this.submitButtonPrice = this.querySelector("#submitButtonPrice");
        console.log(this.submitButton);
        this.form.addEventListener("change", this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      console.log(event.target);
      this.submitButton.href = event.target.value;
      this.submitButtonPrice.innerHTML = '&nbsp;- ' + event.target.dataset.price;
    }
  });
}